import { DefaultUserImage } from 'components/_common/Icons';
import { UTC_TIMEZONE_SLUG } from 'helpers/DateHelper';
import { getImageURL } from 'helpers/FileUploadHelper';

import type { RootState } from 'store';

export const userInfoSelector = (state: RootState) => state.common.auth.userInfo;
export const userFFLInfoSelector = (state: RootState) => state.common.auth.fflInfo as any;
export const userProfileInfoSelector = (state: RootState) => state.common.auth.profileInfo as any;
export const userSettingsSelector = (state: RootState) => state.common.auth.userSettings as any;
export const userProfileImageSelector = (state: any) => {
  const userProfileInfo: any = userProfileInfoSelector(state);
  let profileImage = DefaultUserImage;
  if (userProfileInfo && userProfileInfo.profile_pic) {
    profileImage = getImageURL(userProfileInfo.profile_pic);
  }
  return profileImage;
};
export const userCurrentRoleSelector = (state: any) => {
  const userInfo: any = userInfoSelector(state);
  return userInfo?.selected_role ?? null;
};
export const userCurrentRoleSlugSelector = (state: any) => {
  const userRoleInfo: any = userCurrentRoleSelector(state);
  return userRoleInfo?.slug ?? null;
};
// date time..................
export const datePickerFormatSelector = () => {
  return 'MM/DD/YYYY';
};
export const dateTimePickerFormatSelector = () => {
  return 'MM/DD/YYYY HH:mm';
};
export const dateTimeDisplayFormatSelector = (state: any) => {
  const userSettings: any = userSettingsSelector(state);
  return userSettings?.date_time_format ?? 'MM/DD/YYYY HH:mm';
};
function splitDateTimeFormat(format: string) {
  const timeMatch = format.match(/(HH:mm|hh:mm|HH:mm:ss|hh:mm:ss)/);

  const timeFormat = timeMatch?.[0] ?? '';
  const dateFormat = format.replace(timeFormat, '').trim();

  return { dateFormat, timeFormat };
}
export const dateDisplayFormatSelector = (state: any) => {
  const dateTimeFormat: any = dateTimeDisplayFormatSelector(state);
  const { dateFormat } = splitDateTimeFormat(dateTimeFormat);
  return dateFormat;
};
// timezone.................
export const userTimeZoneObjSelector = (state: any) => {
  const userSettings: any = userSettingsSelector(state);
  return userSettings?.timezone ?? '';
};
export const userTimeZoneSelector = (state: any) => {
  const timezoneObj = userTimeZoneObjSelector(state);
  if (timezoneObj) {
    return timezoneObj?.timezone;
  }
  return UTC_TIMEZONE_SLUG;
};
